import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent.vue?vue&type=template&id=36d08612"
import script from "./RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports